import $ from './lib/jquery';
import 'jquery-ui/ui/version';
import 'jquery-ui/ui/unique-id';
import 'jquery-ui/ui/safe-active-element';
import 'jquery-ui/ui/safe-blur';
import 'jquery-ui/ui/keycode';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/position';
//import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/menu';
import 'slick-carousel/slick/slick';
import 'magnific-popup/dist/jquery.magnific-popup';
import 'jquery-focuspoint/js/jquery.focuspoint';
import 'imagesloaded/imagesloaded';
import 'focus-visible';
import 'bootstrap';
import 'parsleyjs';
import 'rrule/dist/es5/rrule.js';

// import { Calendar } from '@fullcalendar/core';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGridPlugin from '@fullcalendar/timegrid';
// import listPlugin from '@fullcalendar/list';
// import bootstrap from '@fullcalendar/bootstrap';
// import interaction from '@fullcalendar/interaction';
// import customViewPlugin from './custom-view-file';
// import deLocale from '@fullcalendar/core/locales/de';
// import rrulePlugin from '@fullcalendar/rrule';


// /**
//  * Name           : FullCalendar
//  * Beschreibung   : JavaScript Calendar
//  * Parameter      : -
//  * Rückgabe       : -
//  * Bibliothek     : jQuery, https://fullcalendar.io/
//  */
//
// document.addEventListener('DOMContentLoaded', function() {
//     let calendarEl = document.getElementById('calendar');
//
//     let calendar = new Calendar(calendarEl, {
//         plugins: [ rrulePlugin, bootstrap, interaction, dayGridPlugin, timeGridPlugin, listPlugin, customViewPlugin ],
//         //defaultView: 'custom',
//         defaultView: 'listYear',
//         //defaultDate: '2019-11-07',
//         header: {
//             left: 'prev,next today',
//             center: 'title',
//             right: 'listYear,dayGridMonth,timeGridWeek'
//         },
//         locale: deLocale,
//         events: {
//             url: '/public/assets/php/fullcalendar/events.json'
//         }
// /*
//         events: {
//             url: '/public/assets/php/fullcalendar/get-events.php'
//         }
// */
// /*
//         events: [
//             {
//                 "title": "2 RRULE-Eintrag",
//                 "rrule": "DTSTART:20180201T091500Z\nRRULE:FREQ=WEEKLY;INTERVAL=2;UNTIL=20210601;BYDAY=SA,SU",
//                 "duration": "01:30"
//             },
//             {
//                 "title": "3 RRULE-Eintrag",
//                 "rrule": "DTSTART:20160331T103000Z\nRRULE:FREQ=WEEKLY;INTERVAL=2;UNTIL=20250601;BYDAY=SU,MO,FR"
//             }
//         ]
// */
// /*
//         events: [
//             {
//                 title: 'my event',
//                 rrule: 'DTSTART:20160331T103000Z\nRRULE:FREQ=WEEKLY;INTERVAL=2;UNTIL=20250601;BYDAY=SU,MO,FR'
//             }
//         ]
//
//  */
//         /*
//         events: [
//             {
//                 "title": "RRULE-Eintrag",
//                 "rrule": {
//                     "freq"     : "weekly",
//                     "interval" : "5",
//                     "byweekday": [ "mo", "fr" ],
//                     "dtstart"  : "2018-02-01T10:30:00",
//                     "until"    : "2021-06-01"
//                 },
//                 "duration": "02:00"
//             }
//         ]
//         */
//     });
//
//     calendar.render();
// });






$(document).ready(function () {
    /**
     * Name           : Get height of mainnav
     * Beschreibung   : -
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, http://multi-level-push-menu.make.rs/, https://www.smartmenus.org
     */
    function mainnavheight() {
        var mainnavheight = $('#mainnavi').height();
        if (mainnavheight < 200) {
            mainnavheight = 200;
        }
        $('.crop-img').css('height', mainnavheight);
    }
    mainnavheight();

    $(window).resize(function () {
        mainnavheight();
    });


    /**
     * Name           : Multi-Dropdown with bootstrap 4
     * Beschreibung   : Multilevel Dropdown Menu with Bootstrap 4
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, https://jsfiddle.net/bootstrapious/j6zkyog8
     */
    $("ul.dropdown-menu [data-toggle='dropdown']").on("click", function(event) {
        event.preventDefault();
        event.stopPropagation();

        $(this).siblings().toggleClass("show");


        if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
            $('.dropdown-submenu .show').removeClass("show");
        });

    });




    /**
     * Name           :
     * Beschreibung   : mobile Suche via Klick einblenden
     * Parameter      : -
     * RÃ¼ckgabe       : -
     * Bibliothek     : jQuery
     */
    $(".mobile-search").click(function () {
        $(".search-wrapper").toggle();
        $('#globalsearch').focus();
    });
    /*mobiler Menu-Close-Button*/
    $("#close-search").click(function () {
        $(".search-wrapper").hide();
    });



    /**
     * Name           : coverflow
     * Beschreibung   : -
     * Parameter      : -
     * RÃ¼ckgabe       : -
     * Bibliothek     : http://coverflowjs.github.io/coverflow/
     */

    function coverflowinit() {
        $('.coverflow').each(function (i, el) {
            var middle;
            var elem = $(el);
            middle = parseInt(elem.children('.coverflow-item').length / 2);
            console.log(middle);
            $(this).coverflow({
                active: middle,
                angle: 30,
                overlap: 0.2,
            });

            $(this).on('click', ".ui-coverflow-item", function (e) {
                if ($(this).hasClass("ui-state-active")) {
                    return true;
                } else {
                    e.preventDefault();
                }
            });
        });
    }


    // $('.coverflow').imagesLoaded(function () {
    //     coverflowinit();
    // });


    /**
     * Name           : slick
     * Beschreibung   : he last carousel you'll ever need
     * Parameter      : -
     * RÃ¼ckgabe       : -
     * Bibliothek     : http://kenwheeler.github.io/slick/
     */
    $('.article-gallery').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.stage-slider').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
    });

    // Pause/Play-Funkion für den Stage-Slider
    if($(".stage-slider").html()!=null){
        // Play/Pause Button hinzufuegen
        $(".stage-slider").parent().css('position','relative').append('<div class="is_play"><a id="play" href="javascript:;" alt="Bildwechsel der Bühnengalerie starten" title="Bildwechsel abspielen"><span class="icon">►</span></a></div>');
        $(".stage-slider").parent().append('<div class="is_breake"><a id="breake" href="javascript:;" alt="Bildwechsel der Bühnengalerie anhalten" title="Bildwechsel anhalten"><span class="icon">❚❚</span></a></div>');
        // Der Zurueck-Button ist zunaechst ausgeblendet
        $(".is_back").hide();
    }
    // Beim Klick auf Stop wird animation pausiert
    $("#breake").click(function(){
        $('.stage-slider').slick('slickPause');
        $("#breake").hide();
        $("#play").show();
    })

    // Beim Klick auf Play wird animation fortgesetzt
    $("#play").click(function(){
        $('.stage-slider').slick('slickPlay');
        $("#play").hide();
        $("#breake").show();
    })



    /**
     * Name           : MagnificPopup
     * Beschreibung   : PopUps und Lightbox für Artikelbilder, Hinweise und Formulare
     * Parameter      : Klasse des Elements
     * Rückgabe       : -
     * Bibliothek     : jQuery, Magnific Popup (magnific_min.js)
     */
    var groups = {};
    $('.mfp').each(function() {
        var id = parseInt($(this).attr('data-group'), 10);

        if(!groups[id]) {
            groups[id] = [];
        }

        groups[id].push( this );
    });

    $.each(groups, function() {

        $(this).magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            closeBtnInside: false,
            gallery: {
                enabled:true,
                tCounter: '<span class="mfp-counter">%curr% von %total%</span>' // markup of counter
            }
        })

    });

    /**
     * Name           : jQuery focuspoint
     * Beschreibung   : FocusPoint 2
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, https://github.com/jonom/jquery-focuspoint
     */
    $('.focuspoint').focusPoint();

    /**
     * Name           : Responsive Tables
     * Beschreibung   : add bootstrap wrapper to tables, which are added via tinymce
     * Parameter      : -
     * RÃ¼ckgabe       : -
     * Bibliothek     : jQuery
     */
     $("table.jsresponsive").wrap( "<div class='table-responsive'></div>" );





    /**
     * Name           : Parsley Validation
     * Beschreibung   : add bootstrap wrapper to tables, which are added via tinymce
     * Parameter      : -
     * RÃ¼ckgabe       : -
     * Bibliothek     : jQuery
     */
    $('.formgenerator').parsley({
        errorsWrapper: '<div class="error"></div>',
        errorTemplate: '<div class="parsley-error"></div>',
        trigger: 'blur'
    });




    /**
     * Name           : Coverflow, Data from EOPAC-Json
     * Beschreibung   :
     * Parameter      : -
     * RÃ¼ckgabe       : -
     * Bibliothek     : jQuery
     */
    // $.getJSON("https://www.eopac.net/BGX431257/openapi/medialist/neue-romane/?cover=1", function(data){
    //     for (var i = 0, len = data.length; i < len; i++) {
    //         console.log(data[i]);
    //     }
    // });

    // var eopacItems = [];
    // jQuery.getJSON("https://www.eopac.net/BGX431257/openapi/medialist/neue-romane/?cover=1", function(data) {
    //     jQuery.each(data, function (i, item) {
    //         eopacItems[i] = [];
    //         eopacItems[i]['actions'] = item['actions'];
    //         eopacItems[i]['media'] = item['media'];
    //     });
    //     console.log(eopacItems);
    // });

    if( $("#eopac-coverflow").length ){
        var coverflowUrl = $("#eopac-coverflow").data("src");
        jQuery.getJSON(coverflowUrl, function(data) {
                 jQuery.each(data, function (i, item) {
                     for (var obj in data.media) {
                         var title = data.media[obj].title;
                         var link = data.media[obj].url;
                         for (var cover in data.media[obj]) {
                             cover = data.media[obj][cover].cover;
                             if ( (typeof cover !== "undefined") && (cover != '') ){
                                 //console.log("Cover: " + cover);
                                 //console.log(link);
                                 $('#eopac-coverflow').append("<div class=\"coverflow-item\"><a href=\"" + link + "\" aria-label=\"" + title + "\" target=\"blank\"><img src=\"" + cover + "\" alt=\"Cover\"\n" +
                                     "                                                                 title=\"Cover\"/></a><br /><a class=\"morelink\"href=\"" + link + "\" target=\"blank\">Zum Katalogeintrag</a></div>");
                             }
                         }
                     }
                 });
            $('.coverflow').imagesLoaded(function () {
                coverflowinit();
            });
        });
    }





    /**
     * Name           : Searchresults
     * Beschreibung   :
     * Parameter      : -
     * RÃ¼ckgabe      : -
     * Bibliothek     : jQuery
     */
    if ( $( ".searchlist" ).length ) {
        var searchhits = $('.searchlist').data("search-hits");
        $('.hits').text(searchhits);
    }





    /**
     * Name           : Autocomplete
     * Beschreibung   : Autocomplete/Autosuggest für Suche
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery
     */
    if ( $('#globalsearch').length){

        /*Variables*/
        var searchfields = $('#globalsearch');
        var searchlayerEntries= $('.searchlayer-entries');
        var $list = $('.autocomplete-list');
        var searchterm;
        var getSlug = require('speakingurl');

        /*Focus Search*/
        searchfields.click(function() {
            $(this).addClass('focus');

        });

        /*Blur Search*/
        document.addEventListener('mouseup', function(e) {
            var container = document.getElementById('searchfield-wrapper');
            if (!container.contains(e.target)) {
                searchfields.removeClass('focus');
                searchlayerEntries.hide();
            }
        });

        // start searching after debounce
        searchfields.keyup( searchInput );

        function searchInput() {
            var input = $(this).val();
            if (input.length >= 3) {
                startSearch(input);
                searchlayerEntries.show();
            }
        }

        function startSearch(searchText) {
            $.ajax({
                url: "https://www.stadtbibliothek-rottenburg.de/api/LibSuggestApi.php",
                dataType: "json",
                data: {
                    search: searchText
                },
                success: function(data) {
                    searchterm = searchText;
                    var response = data;
                    $(".autosuggest-hits").show();
                    // clear list and detail
                    $list.html('');

                    response.forEach(function(item) {
                        var $listItem = $('<li class="menu-item" />');
                        var $itemUrl = '/' + getSlug(item.title) + '.' + item.id + '.htm';
                        var $itemLink = $('<a class="menu-item-wrapper" />').attr('href', $itemUrl);
                        //var $itemArea = $('<div class="area"/>').text(item.area);
                        var $itemText = $('<span/>').text(item.title);
                        $itemLink.append($itemText);
                        $listItem.attr('data-preview', item.preview).append($itemLink).appendTo($list);
                    });

                    //See all results
                    $('.autocomplete-list').prepend('<li class=\"pinned primary-bg\"><a class=\"trigger-submit btn btn-primary btn-lg\" href=\"https://sb-rottenburg.lmscloud.net/cgi-bin/koha/opac-search.pl?q=' + searchterm + '\" target=\"_blank\">Ergebnisse Ihrer Suchanfrage im Bibliothekskatalog</a></li>');
                    $('.autocomplete-list .trigger-submit').click(function(e) {
                        $('.searchlayer .search').submit();
                    });

                    //No Results
                    if ($.trim(response) == '' ) {
                        $('.autocomplete-list').append('<li>Keine Ergebnisse im Titel gefunden. <a href="https://www.rottenburg.de/suche.124977.htm?search=' + searchText + '">Suche im Volltext fortsetzen.</a></li>');
                        return;
                    }

                }
            });
        }
    }


});